export default __webpack_public_path__ + "static/media/key_features_deployments.ad7a6f5b.svg";